import { appPath } from '@featit/shared/addressing/paths';

/** F-0271 RL-5e: where a guest reads what is shared with them. */
export const SHARED_WITH_YOU_PATH = appPath('/shared');

const WORK_AREA_PARAM = 'workArea';
const ITEM_PARAM = 'item';

/**
 * F-0621 (AGM-46): an item as a guest reads it — Shared with you, with that item open. The work area
 * is named by id, as the shared items are, so a key that two work areas share opens the right one.
 */
export function sharedWithYouItemPath(workAreaId: string, itemKey: string): string {
  const params = new URLSearchParams();
  params.set(WORK_AREA_PARAM, workAreaId);
  params.set(ITEM_PARAM, itemKey);
  return `${SHARED_WITH_YOU_PATH}?${params.toString()}`;
}

/**
 * I-2447: one shared item read on its own, full width, with no list around it — where "See your
 * request" takes a customer who has just filed. The work area by id, as in `sharedWithYouItemPath`.
 */
export function sharedRequestPath(workAreaId: string, itemKey: string): string {
  return `${SHARED_WITH_YOU_PATH}/${encodeURIComponent(workAreaId)}/${encodeURIComponent(itemKey)}`;
}

/** The item a Shared with you address asks to open, or null when it names none. */
export function sharedItemLinkOf(search: string): { workAreaId: string; key: string } | null {
  const params = new URLSearchParams(search);
  const workAreaId = params.get(WORK_AREA_PARAM);
  const key = params.get(ITEM_PARAM);
  return workAreaId && key ? { workAreaId, key } : null;
}

/**
 * The item key a work-area route names (`/items/KEY`, and any route under it), or null. `items/new`
 * files an item and names none.
 */
export function itemKeyOfRoute(route: string): string | null {
  const match = /^\/items\/([^/]+)(?:\/.*)?$/.exec(route);
  if (!match) return null;
  const key = decodeURIComponent(match[1]);
  return key === 'new' ? null : key;
}
